import { useParams } from "react-router";
import { useGet } from "./hooks";
import { useSession, can, type Perm, type Role } from "./session";

/** Espace courant (d'après l'URL /espace/:orgId) et rôle de l'utilisateur. */
export function useOrg() {
  const { orgId = "" } = useParams();
  const { memberships } = useSession();
  const m = memberships.find((x) => x.org_id === orgId);
  return {
    orgId,
    orgName: m?.org_name ?? "",
    orgKind: m?.org_kind ?? "",
    planCode: m?.plan_code ?? "",
    role: m?.role as Role | undefined,
    can: (p: Perm) => can(m?.role, p),
    /** Préfixe des routes d'API de l'espace. */
    api: (path: string) => `/api/v1/orgs/${orgId}${path.startsWith("/") ? path : `/${path}`}`,
    /** Préfixe des pages de l'espace. */
    to: (path = "") => `/espace/${orgId}${path ? (path.startsWith("/") ? path : `/${path}`) : ""}`,
  };
}

/** Collaborateur dont l'accès est limité aux logements attribués (F-091) : le serveur lui refuse les vues globales. */
export function useRestricted(): boolean {
  const org = useOrg();
  const scope = useGet<{ restricted: boolean }>(org.role === "collaborateur" ? org.api("/pro/scope") : null);
  return scope.data?.restricted === true;
}
